import { ibow2_proto_PortalOfficeListingImportantDocument } from '@/init/swagger';

type BasicImportantDocument = {
  file_name?: string;
};
export type FileImportantDocument = BasicImportantDocument & {
  document_type: 'file';
  file_type?: 'image' | 'pdf' | 'office';
  file_path?: string;
  file_signed_url?: string;
  file_url?: string;
};
export type TextImportantDocument = BasicImportantDocument & {
  document_type: 'text';
  document_text?: string;
};

type AcceptableFileType = {
  extension: string;
  type: 'pdf' | 'office' | 'image';
  officeType?: 'doc' | 'ppt' | 'xls';
};

export const acceptableFileTypes: AcceptableFileType[] = [
  {
    extension: '.pdf',
    type: 'pdf',
  },
  {
    extension: '.jpg',
    type: 'image',
  },
  {
    extension: '.jpeg',
    type: 'image',
  },
  {
    extension: '.png',
    type: 'image',
  },
  {
    extension: '.doc',
    type: 'office',
    officeType: 'doc',
  },
  {
    extension: '.docx',
    type: 'office',
    officeType: 'doc',
  },
  {
    extension: '.xls',
    type: 'office',
    officeType: 'xls',
  },
  {
    extension: '.xlsx',
    type: 'office',
    officeType: 'xls',
  },
  {
    extension: '.ppt',
    type: 'office',
    officeType: 'ppt',
  },
  {
    extension: '.pptx',
    type: 'office',
    officeType: 'ppt',
  },
];

export const maxImportantDocuments = 10;

export type ImportantDocument = FileImportantDocument | TextImportantDocument;

export function getTextImportantDocument(
  fileName: string,
  documentText: string,
): TextImportantDocument {
  return {
    document_type: 'text',
    file_name: fileName,
    document_text: documentText,
  };
}

export function getFileImportantDocument(
  fileName: string,
  filePath: string,
  fileSignedUrl: string,
): FileImportantDocument {
  const fileType = acceptableFileTypes.find((fileType) =>
    filePath.endsWith(fileType.extension),
  );
  return {
    document_type: 'file',
    file_name: fileName,
    file_path: filePath,
    file_signed_url: fileSignedUrl,
    file_url: decodeURIComponent(fileSignedUrl),
    file_type: fileType ? fileType.type : 'pdf',
  };
}

function parseImportantDocument(
  importantDocument: ibow2_proto_PortalOfficeListingImportantDocument,
): ImportantDocument | undefined {
  if (
    importantDocument.file_name &&
    importantDocument.file_path &&
    importantDocument.file_signed_url
  ) {
    return getFileImportantDocument(
      importantDocument.file_name,
      importantDocument.file_path,
      importantDocument.file_signed_url,
    );
  } else if (importantDocument.file_name && importantDocument.document_text) {
    return getTextImportantDocument(
      importantDocument.file_name,
      importantDocument.document_text,
    );
  }
  return;
}

export function parseImportantDocuments(
  importantDocuments?: ibow2_proto_PortalOfficeListingImportantDocument[],
): ImportantDocument[] {
  if (!importantDocuments) {
    return [];
  }
  // バックエンドで最大数が保証されていないのでフロントエンド側でトリミングする
  return importantDocuments
    .slice(0, maxImportantDocuments)
    .map((importantDocument) => parseImportantDocument(importantDocument))
    .filter((importantDocument) => !!importantDocument) as ImportantDocument[];
}
